// var github_topics = require('github-topics');
// var topics = github_topics.gettopics('https://github.com/Code-Beast/bootstrap');
// console.log(topics);

module.exports = (apiToken) => { 
  const GithubREST = require('@octokit/rest');
  const ghREST = new GithubREST({
    auth: apiToken,
  });
  const ghGraphQL = require('@octokit/graphql');
  
  // Get a list of all topics of a repo
  const getTopics = async (owner, repo) => {
    try {
      const res = await ghREST.repos.listTopics({
        owner,
        repo,
        headers: {
          Accept: 'application/vnd.github.mercy-preview+json'
        },
      });
      return res.data.names;
    } catch (err) {
      console.log(`Some error occurred when we were fetching topics info of repo ${owner}/${repo}`);
      return [];
    }
  };
  
  // Get the total number of repos of a user or an organization
  const getRepoCount = async (owner) => {
    const res = await ghGraphQL(`{
      search(query: "user:${owner} fork:true", type: REPOSITORY) {
        repositoryCount
      }
    }`, {
      headers: {
        authorization: `token ${apiToken}`,
      }
    });
    return res.search.repositoryCount;
  };
  
  // Get a list of all repo names of a user or an organization using github rest api
  // Here, listForUser cover both users and orgs. If you want to only cover org, user listFor Org with `org: ${orgName}`
  const getRepoNames = async (owner) => {
    let repoCount;
    try {
      repoCount = await getRepoCount('yahoo');
    } catch (err) {
      console.log(`Some error occurred when we were getting the number of repos owned by ${owner}`);
      return [];
    }

    const pageCount = Math.ceil(repoCount / 100);
  
    // Python style range function
    const range = n => Array.from(Array(n).keys());
  
    const results = await Promise.all(range(pageCount).map((idx) => {
      try {
        return ghREST.repos.listForUser({
          username: owner,
          per_page: 100,
          page: idx + 1,
        });
      } catch (err) {
        console.log(`Some error occurred when we were getting repo names of repo page ${idx} owned by ${owner}`);
        return [];
      }
    }));
  
    return results.reduce((prevRepos, curResult) => {
      const curRepos = curResult.data.map((repo) => repo.name);
      return [...new Set(prevRepos.concat(curRepos))];
    }, []);
  };
  
  // Test: get a list of repo names of an organization (first 100)
  // Note: with graphql, you can at most retrive 100 repo names
  // (async () => {
  //   const res = await ghGraphQL(`{
  //     search(query: "org:yahoo", type: REPOSITORY, first: 100) {
  //       repositoryCount
  //       pageInfo {
  //         endCursor
  //         startCursor
  //       }
  //       edges {
  //         node {
  //           ... on Repository {
  //             name
  //           }
  //         }
  //       }
  //     }
  //   }`, {
  //     headers: {
  //       authorization: 'token 116423ec00659a0d15e2ee62d1a9778c3617f162',
  //     }
  //   });
  //   return res.search.edges.map((edge) => edge.node.name);
  // })().then((repos) => {
  //   console.log(repos);
  // }).catch((err) => {
  //   console.log(err);
  // });

  // Get some basic info of a repo: name, language, description, link, fork times, stars
  const getInfo = async (owner, repo) => {
    try {
      const res = await ghGraphQL(`{
        repository(owner: "${owner}", name: "${repo}") {
          description,
          url,
          primaryLanguage {
            color,
            name
          },
          forkCount,
          stargazers {
            totalCount
          },
        }
      }`, {
        headers: {
          authorization: `token ${apiToken}`,
        }
      });

      const repoInfo = res.repository;
      repoInfo.starCount = repoInfo.stargazers.totalCount;
      delete repoInfo.stargazers;

      return repoInfo;
    } catch (err) {
      console.log(`Some error occurred when we were getting the info of ${owner}/${repo}`);
      return {
        error: 'Cannot obtain details from Gibhub.'
      }
    }
  }

  // get a list of repos of an organization or a user including topics information
  const getRepos = async (ownerType, owner) => {
    let endCursor = '';
    let res = {};
    
    while (endCursor !== null) {
      const response = await ghGraphQL(`{
        ${ownerType}(login: "${owner}") {
          repositories(first: 100${endCursor === '' ? '' : `after: "${endCursor}"`}) {
            pageInfo {
              endCursor
            }
            totalCount
            edges {
              node {
                name
                description
                primaryLanguage {
                  color
                  name
                }
                stargazers {
                  totalCount
                }
                url
                forkCount
                repositoryTopics(first: 100) {
                  edges {
                    node {
                      topic {
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }`, {
        headers: {
          authorization: `token ${apiToken}`,
        }
      });
      endCursor = response[ownerType].repositories.pageInfo.endCursor;
      const edges = response[ownerType].repositories.edges;
      edges.forEach((edge) => {
        const repo = edge.node;
        const starCount = repo.stargazers.totalCount;
        const topics = repo.repositoryTopics.edges.map((repositoryTopic) => {
          return repositoryTopic.node.topic.name;
        })

        delete repo.stargazers;
        delete repo.repositoryTopics;

        res[repo.name] = {
          ...repo,
          starCount,
          topics
        };
      });
    }

    return res;
  };

  // get a list of repos of an organization including topics information
  const getOrgRepos = async (org) => {
    return await getRepos('organization', org);
  };

  // get a list of repos of a user including topics information
  const getUserRepos = async (user) => {
    return await getRepos('user', user);
  }

  return { getTopics, getRepoNames, getInfo, getOrgRepos, getUserRepos };
};


// WEBPACK FOOTER //
// ./src/lib/utils/ghUtils.js